import dashboardIcon from '../assets/icons/dashboard.svg';
import dashboardActiveIcon from '../assets/icons/dashboardActive.svg';
import operationsIcon from '../assets/icons/operations.svg';
import operationsActiveIcon from '../assets/icons/operationsActive.svg';
import checklistIcon from '../assets/icons/checklist.svg';
import checklistActiveIcon from '../assets/icons/checklistActive.svg';
import tasksIcon from '../assets/icons/tasks.svg';
import tasksActiveIcon from '../assets/icons/tasksActive.svg';
import malfunctionsIcon from '../assets/icons/malfunctions.svg';
import malfunctionsActiveIcon from '../assets/icons/malfunctionsActive.svg';
import regulationsIcon from '../assets/icons/regulations.svg';
import regulationsActiveIcon from '../assets/icons/regulationsActive.svg';
import workingIcon from '../assets/icons/working.svg';
import workingActiveIcon from '../assets/icons/workingActive.svg';
import equipmentAndInstrumentsIcon from '../assets/icons/equipment&Instruments.svg';
import equipmentAndInstrumentsActiveIcon from '../assets/icons/equipment&InstrumentsActive.svg';
import usersIcon from '../assets/icons/users.svg';
import usersActiveIcon from '../assets/icons/usersActive.svg';
import suppliersIcon from '../assets/icons/suppliers.svg';
import suppliersActiveIcon from '../assets/icons/suppliersActive.svg';
import tutorialsIcon from '../assets/icons/tutorials.svg';
import tutorialsActiveIcon from '../assets/icons/tutorialsActive.svg';
import reportsIcon from '../assets/icons/reports.svg';
import reportsActiveIcon from '../assets/icons/reportsActive.svg';
import settingsIcon from '../assets/icons/settings.svg';
import logoutIcon from '../assets/icons/logout.svg';
import addIcon from '../assets/icons/add.svg';
import addBlueIcon from '../assets/icons/addBlue.svg';
import addGrayIcon from '../assets/icons/addGray.svg';
import dropdownIcon from '../assets/icons/dropdown.svg';
import diamondIcon from '../assets/icons/diamond.svg';
import calendarIcon from '../assets/icons/calendar.svg';
import searchIcon from '../assets/icons/search.svg';
import filterIcon from '../assets/icons/filter.svg';
import greaterThanIcon from '../assets/icons/greaterThan.svg';
import greaterThanGrayIcon from '../assets/icons/greaterThanGray.svg';
import lessThanIcon from '../assets/icons/lessThan.svg';
import lessThanGrayIcon from '../assets/icons/lessThanGray.svg';
import lessThanBlueIcon from '../assets/icons/lessThanBlue.svg';
import blueLessThan from '../assets/icons/blueLessThan.svg';
import expandIcon from '../assets/icons/expand.svg';
import filterSidebarAllIcon from '../assets/icons/filterSidebarAll.svg';
import filterSidebarRegulationIcon from '../assets/icons/filterSidebarRegulation.svg';
import filterSidebarRestaurantIcon from '../assets/icons/filterSidebarRestaurant.svg';
import filterSidebarKitchenIcon from '../assets/icons/filterSidebarKitchen.svg';
import filterSidebarBarIcon from '../assets/icons/filterSidebarBar.svg';
import filterSidebarAdministrationIcon from '../assets/icons/filterSidebarAdministration.svg';
import threeDotsIcon from '../assets/icons/threeDots.svg';
import redTriangleIcon from '../assets/icons/redTriangle.svg';
import grayTriangleIcon from '../assets/icons/grayTriangle.svg';
import completedCheckboxIcon from '../assets/icons/completedCheckbox.svg';
import regularCheckboxIcon from '../assets/icons/regularCheckbox.svg';
import regularDoneCheckboxIcon from '../assets/icons/regularDoneCheckbox.svg';
import yellowCheckboxIcon from '../assets/icons/yellowCheckbox.svg';
import yellowDoneCheckboxIcon from '../assets/icons/yellowDoneCheckbox.svg';
import redCheckboxIcon from '../assets/icons/redCheckbox.svg';
import redDoneCheckboxIcon from '../assets/icons/redDoneCheckbox.svg';
import taskIcon from '../assets/icons/task.svg';
import listIcon from '../assets/icons/list.svg';
import assignedIcon from '../assets/icons/assigned.svg';
import tickIcon from '../assets/icons/tick.svg';
import deleteIcon from '../assets/icons/delete.svg';
import deleteGrayIcon from '../assets/icons/deleteGray.svg';
import editGrayIcon from '../assets/icons/editGray.svg';
import videoIcon from '../assets/icons/video.svg';
import calendarGrayIcon from '../assets/icons/calendarGray.svg';
import printerGrayIcon from '../assets/icons/printerGray.svg';
import shareGrayIcon from '../assets/icons/shareGray.svg';
import expandGrayIcon from '../assets/icons/expandGray.svg';
import collapseAllIcon from '../assets/icons/collapseAll.svg';
import downBlueIcon from '../assets/icons/downBlue.svg';
import expandScreenGrayIcon from '../assets/icons/expandScreenGray.svg';
import closeGrayIcon from '../assets/icons/closeGray.svg';
import checkGrayIcon from '../assets/icons/checkGray.svg';
import closeDarkIcon from '../assets/icons/closeDark.svg';
import menuDarkIcon from '../assets/icons/menuDark.svg';
import descriptionDarkIcon from '../assets/icons/descriptionDark.svg';
import saveAllIcon from '../assets/icons/saveAll.svg';
import loadingIcon from '../assets/icons/loading.svg';
import warningIcon from '../assets/icons/warning.svg';
import forkNKnifeIcon from '../assets/icons/forknKnife.svg';
import kitchenSmallIcon from '../assets/icons/kitchenSmall.svg';
import barSmallIcon from '../assets/icons/barSmall.svg';
import administrationSmallIcon from '../assets/icons/administrationSmall.svg';
import regularAnnouncementIcon from '../assets/icons/regularAnnouncement.svg';
import settingBlackIcon from '../assets/icons/settingBlack.svg';
import peopleIcon from '../assets/icons/people.svg';
import clockIcon from '../assets/icons/clock.svg';
import cameraIcon from '../assets/icons/camera.svg';
import fileIcon from '../assets/icons/file.svg';
import imageIcon from '../assets/icons/image.svg';
import movieIcon from '../assets/icons/movie.svg';
import pdfIcon from '../assets/icons/pdf.svg';
import wordIcon from '../assets/icons/word.svg';
import equipmentIcon from '../assets/icons/equipment.svg';
import equipmentCardIcon from '../assets/icons/equipmentCard.svg';
import completeCheckboxWhiteIcon from '../assets/icons/completeCheckBoxWhite.svg';
import chatBlackIcon from '../assets/icons/chatBlack.svg';
import listDeleteIcon from '../assets/icons/listDelete.svg';
import listDeleteRedIcon from '../assets/icons/listDeleteRed.svg';
import expandSectionGrayIcon from '../assets/icons/expandSectionGray.svg';
import imageSmallIcon from '../assets/icons/imageSmall.svg';
import chatSmallIcon from '../assets/icons/chatSmall.svg';
import tickGreenIcon from '../assets/icons/tickGreen.svg';
import deleteRedIcon from '../assets/icons/deleteRed.svg';
import linkBlackIcon from '../assets/icons/linkBlack.svg';
import clientIcon from '../assets/icons/client.svg';
import dropUpIcon from '../assets/icons/dropUp.svg';
import editSettingIcon from '../assets/icons/editSetting.svg';
import editPencilWhiteIcon from '../assets/icons/editPencilWhite.svg';
import addWhiteIcon from '../assets/icons/addWhite.svg';
import dropdownWhiteIcon from '../assets/icons/dropdownWhite.svg';
import csvGreenIcon from '../assets/icons/csvGreen.svg';
import printerBlackIcon from '../assets/icons/printerBlack.svg';
import downArrowBlackIcon from '../assets/icons/downArrowBlack.svg';
import downArrowGrayIcon from '../assets/icons/downArrowGray.svg';
import userDarkIcon from '../assets/icons/userDark.svg';
import contactDarkIcon from '../assets/icons/contactDark.svg';
import emailDarkIcon from '../assets/icons/emailDark.svg';
import birthdateDarkIcon from '../assets/icons/birthdateDark.svg';
import israelFlagIcon from '../assets/icons/israelFlag.svg';
import resetPasswordIcon from '../assets/icons/resetPassword.svg';
import excelGreenIcon from '../assets/icons/excelGreen.svg';
import excelGreenLgIcon from '../assets/icons/excelGreenLg.svg';
import printerAquaLgIcon from '../assets/icons/printerAquaLg.svg';
import roleDarkIcon from '../assets/icons/roleDark.svg';
import outlinePencilDarkIcon from '../assets/icons/outlinePencilDark.svg';
import role1Icon from '../assets/icons/role1.svg';
import role2Icon from '../assets/icons/role2.svg';
import role3Icon from '../assets/icons/role3.svg';
import role4Icon from '../assets/icons/role4.svg';
import role5Icon from '../assets/icons/role5.svg';
import role6Icon from '../assets/icons/role6.svg';
import role7Icon from '../assets/icons/role7.svg';
import role8Icon from '../assets/icons/role8.svg';
import role9Icon from '../assets/icons/role9.svg';
import role10Icon from '../assets/icons/role10.svg';
import role11Icon from '../assets/icons/role11.svg';
import role12Icon from '../assets/icons/role12.svg';
import role13Icon from '../assets/icons/role13.svg';
import role14Icon from '../assets/icons/role14.svg';
import role15Icon from '../assets/icons/role15.svg';
import role16Icon from '../assets/icons/role16.svg';
import role17Icon from '../assets/icons/role17.svg';
import role18Icon from '../assets/icons/role18.svg';
import role19Icon from '../assets/icons/role19.svg';
import role20Icon from '../assets/icons/role20.svg';
import role21Icon from '../assets/icons/role21.svg';
import role22Icon from '../assets/icons/dish.svg';
import role23Icon from '../assets/icons/role23.svg';
import role24Icon from '../assets/icons/role24.svg';
import role25Icon from '../assets/icons/role25.svg';
import role26Icon from '../assets/icons/role26.svg';
import role27Icon from '../assets/icons/role27.svg';
import role28Icon from '../assets/icons/role28.svg';
import role29Icon from '../assets/icons/role29.svg';
import role30Icon from '../assets/icons/role30.svg';
import role31Icon from '../assets/icons/role31.svg';
import role32Icon from '../assets/icons/role32.svg';
import role33Icon from '../assets/icons/role33.svg';
import partiallyCompleteCheckboxIcon from '../assets/icons/partiallyCompleteCheckboxIcon.svg';
import whiteCloseIcon from '../assets/icons/whiteClose.svg';
import eyeOnIcon from '../assets/icons/eyeOn.svg';
import eyeOffIcon from '../assets/icons/eyeOff.svg';
import appLogoIcon from '../assets/icons/appLogo.svg';
import dropdownGrayIcon from '../assets/icons/dropdownGray.svg';
import binBlackIcon from '../assets/icons/binBlack.svg';
import admin from '../assets/icons/admin-user.svg';
import shiftManager from '../assets/icons/shift-manager.svg';
import bar from '../assets/icons/bar.svg';
import barManager from '../assets/icons/bar-manager.svg';
import bookKeeper from '../assets/icons/book-keeper.svg';
import lineCook from '../assets/icons/line-cook.svg';
import waiter from '../assets/icons/waiter.svg';
import restaurantChainManager from '../assets/icons/restaurant-chain-manager.svg';
import restaurantTrainee from '../assets/icons/restaurant-trainee.svg';
import pastryChef from '../assets/icons/pastry-chef.svg';
import chef from '../assets/icons/chef.svg';
import checkTickBg from '../assets/icons/checkTickBg.svg';
import passwordLock from '../assets/icons/password-lock.svg';
import editPenCircle from '../assets/icons/edit-pen-circle.svg';
import regularAnnouncementRedIcon from '../assets/icons/regularAnnouncementRed.svg';
import tutorialsActiveRedIcon from '../assets/icons/tutorialsActiveRed.svg';
import administrationRedIcon from '../assets/icons/administrationRed.svg';
import settingRedIcon from '../assets/icons/settingRed.svg';
import lock from '../assets/icons/lock.svg';
import regulationPartial from '../assets/icons/partialYellow.svg';
import errorPartial from '../assets/icons/partialError.svg';
import aquaTick from '../assets/icons/aquaTick.svg';
import copyWhiteIcon from '../assets/icons/copyWhite.svg';
import ActiveAlert from '../assets/icons/AlertActive.svg';
import InactiveAlert from '../assets/icons/AlertInactive.svg';
import CollapseBlack from '../assets/icons/colapseBlack.svg';
import ExpandBlack from '../assets/icons/ExpandBlack.svg';
import closeRedIcon from '../assets/icons/closeRed.svg';
import thumbsUpGrayIcon from '../assets/icons/thumbsUpGray.svg';
import thumbsUpGreenIcon from '../assets/icons/thumbsUpGreen.svg';
import thumbsUpBlueIcon from '../assets/icons/thumbsUpBlue.svg';
import organizationGrayIcon from '../assets/icons/organizationGray.svg';
import darkStarIcon from '../assets/icons/darkStar.svg';
import QRDarkIcon from '../assets/icons/QRDark.svg';
import shareDarkIcon from '../assets/icons/shareDark.svg';
import copyDarkIcon from '../assets/icons/copyDark.svg';
import cloneDarkIcon from '../assets/icons/cloneDark.svg';
import shortAnswerTypeIcon from '../assets/icons/shortAnswerType.svg';
import multipleChoiceTypeIcon from '../assets/icons/multipleChoiceType.svg';
import checkboxTypeIcon from '../assets/icons/checkboxType.svg';
import linearScaleTypeIcon from '../assets/icons/linearScaleType.svg';
import ratingTypeIcon from '../assets/icons/ratingType.svg';
import dateTypeIcon from '../assets/icons/dateType.svg';
import timeTypeIcon from '../assets/icons/timeType.svg';
import emptyStarIcon from '../assets/icons/emptyStar.svg';
import filledStarIcon from '../assets/icons/filledStar.svg';
import filledStarDropdownIcon from '../assets/icons/filledStarDropdown.svg';
import emptyHeartIcon from '../assets/icons/emptyHeart.svg';
import filledHeartIcon from '../assets/icons/filledHeart.svg';
import filledHeartDropdownIcon from '../assets/icons/filledHeartDropdown.svg';
import emptySmileIcon from '../assets/icons/emptySmile.svg';
import filledSmileIcon from '../assets/icons/filledSmile.svg';
import filledSmileDropdownIcon from '../assets/icons/filledSmileDropdown.svg';
import emptyGlassIcon from '../assets/icons/emptyGlass.svg';
import filledGlassIcon from '../assets/icons/filledGlass.svg';
import filledGlassDropdownIcon from '../assets/icons/filledGlassDropdown.svg';
import calendarBlackIcon from '../assets/icons/calendarBlack.svg';
import prevBlackIcon from '../assets/icons/prevBlack.svg';
import nextBlackIcon from '../assets/icons/nextBlack.svg';
import lessThanWhiteIcon from '../assets/icons/lessThanWhite.svg';
import exclamationCircleIcon from '../assets/icons/exclamation-circle.svg';
import micIcon from '../assets/icons/mic.svg';
import timeIcon from '../assets/icons/time.svg';
import tableIcon from '../assets/icons/table.svg';
import whatsAppIcon from '../assets/icons/whatsApp.svg';
import emailIcon from '../assets/icons/email.svg';
import quickTypeIcon from '../assets/icons/quickType.svg';
import draftBlueIcon from '../assets/icons/draftBlue.svg';
import tableReservationGrayIcon from '../assets/icons/tableReservationGray.svg';
import printTableIcon from '../assets/icons/printTable.svg';
import menuTypeIcon from '../assets/icons/menuType.svg';
import dropdownQuestionTypeIcon from '../assets/icons/dropdownQuestionType.svg';
import uploadQuestionTypeIcon from '../assets/icons/uploadQuestionType.svg';
import rangeQuestionTypeIcon from '../assets/icons/rangeQuestionType.svg';
import regularAnnouncementOutlineIcon from '../assets/icons/regularAnnouncementOutline.svg';
import aquaStarIcon from '../assets/icons/aquaStar.svg';
import logoutWhiteIcon from '../assets/icons/logoutWhite.svg';
import logoIcon from '../assets/icons/logo.svg';
import logoDarkIcon from '../assets/icons/logoDark.svg';
import cheqqItTickIcon from '../assets/icons/cheqqItTick.svg';
import networkBlackIcon from '../assets/icons/networkBlack.svg';
import editSettingsWhiteIcon from '../assets/icons/editSettingsWhite.svg';
import imgPlaceholderWhiteIcon from '../assets/icons/imgPlaceholderWhite.svg';
import goBackIcon from '../assets/icons/goBack.svg';
import addDarkBlueIcon from '../assets/icons/addDarkBlue.svg';
import copyGrayIcon from '../assets/icons/copyGray.svg';
import infoBlueIcon from '../assets/icons/infoBlue.svg';
import tickWhiteIcon from '../assets/icons/tickWhiteIcon.svg';
import folderBlackIcon from '../assets/icons/folderBlack.svg';
import reWindGrayIcon from '../assets/icons/rewindGray.svg';
import bellBlackIcon from '../assets/icons/bellBlack.svg';
import yellowCircleIcon from '../assets/icons/yellowCircle.svg';
import grayCircleIcon from '../assets/icons/grayCircle.svg';
import activateCheckIcon from '../assets/icons/activateCheck.svg';
import activeCheckIcon from '../assets/icons/activeCheck.svg';
import arrowRound from '../assets/icons/arrow-round.svg';
import regulationBadgeGroup from '../assets/icons/regulation-badge-group.svg';
import regulationBadgeIcon from '../assets/icons/regulationBadge.svg';
import validationErrorOnboarding from '../assets/icons/validationErrorOnboarding.svg';
import bellFilledBlackIcon from '../assets/icons/bellFilledBlack.svg';
import daySummrayIcon from '../assets/icons/daySummray.svg';
import enterArrowIcon from '../assets/icons/enterArrow.svg';
import checkTickIcon from '../assets/icons/checkTickIcon.svg';
import networkParentIcon from '../assets/icons/networkParentIcon.svg';

export const SVG = {
  CollapseBlack,
  ExpandBlack,

  ActiveAlert,
  InactiveAlert,
  aquaTick,
  lock,
  dashboardIcon,
  dashboardActiveIcon,
  operationsIcon,
  operationsActiveIcon,
  checklistIcon,
  checklistActiveIcon,
  tasksIcon,
  tasksActiveIcon,
  malfunctionsIcon,
  malfunctionsActiveIcon,
  regulationsIcon,
  regulationsActiveIcon,
  workingIcon,
  workingActiveIcon,
  equipmentAndInstrumentsIcon,
  equipmentAndInstrumentsActiveIcon,
  usersIcon,
  usersActiveIcon,
  suppliersIcon,
  suppliersActiveIcon,
  tutorialsIcon,
  tutorialsActiveIcon,
  reportsIcon,
  reportsActiveIcon,
  settingsIcon,
  logoutIcon,
  addIcon,
  addBlueIcon,
  addGrayIcon,
  dropdownIcon,
  diamondIcon,
  calendarIcon,
  searchIcon,
  filterIcon,
  lessThanIcon,
  lessThanGrayIcon,
  lessThanBlueIcon,
  blueLessThan,
  greaterThanIcon,
  greaterThanGrayIcon,
  expandIcon,
  filterSidebarAllIcon,
  filterSidebarRegulationIcon,
  filterSidebarRestaurantIcon,
  filterSidebarKitchenIcon,
  filterSidebarBarIcon,
  filterSidebarAdministrationIcon,
  threeDotsIcon,
  redTriangleIcon,
  grayTriangleIcon,
  completedCheckboxIcon,
  regularCheckboxIcon,
  regularDoneCheckboxIcon,
  yellowCheckboxIcon,
  yellowDoneCheckboxIcon,
  redCheckboxIcon,
  redDoneCheckboxIcon,
  taskIcon,
  listIcon,
  assignedIcon,
  tickIcon,
  deleteIcon,
  deleteGrayIcon,
  editGrayIcon,
  videoIcon,
  calendarGrayIcon,
  printerGrayIcon,
  shareGrayIcon,
  expandGrayIcon,
  collapseAllIcon,
  downBlueIcon,
  expandScreenGrayIcon,
  closeGrayIcon,
  checkGrayIcon,
  closeDarkIcon,
  menuDarkIcon,
  descriptionDarkIcon,
  saveAllIcon,
  loadingIcon,
  warningIcon,
  forkNKnifeIcon,
  kitchenSmallIcon,
  barSmallIcon,
  administrationSmallIcon,
  regularAnnouncementIcon,
  settingBlackIcon,
  peopleIcon,
  clockIcon,
  cameraIcon,
  fileIcon,
  imageIcon,
  movieIcon,
  pdfIcon,
  wordIcon,
  equipmentIcon,
  equipmentCardIcon,
  completeCheckboxWhiteIcon,
  chatBlackIcon,
  listDeleteIcon,
  listDeleteRedIcon,
  expandSectionGrayIcon,
  imageSmallIcon,
  chatSmallIcon,
  tickGreenIcon,
  deleteRedIcon,
  linkBlackIcon,
  clientIcon,
  dropUpIcon,
  editSettingIcon,
  editPencilWhiteIcon,
  addWhiteIcon,
  dropdownWhiteIcon,
  csvGreenIcon,
  printerBlackIcon,
  downArrowBlackIcon,
  downArrowGrayIcon,
  userDarkIcon,
  contactDarkIcon,
  emailDarkIcon,
  birthdateDarkIcon,
  israelFlagIcon,
  resetPasswordIcon,
  excelGreenIcon,
  excelGreenLgIcon,
  printerAquaLgIcon,
  roleDarkIcon,
  outlinePencilDarkIcon,
  role1Icon,
  role2Icon,
  role3Icon,
  role4Icon,
  role5Icon,
  role6Icon,
  role7Icon,
  role8Icon,
  role9Icon,
  role10Icon,
  role11Icon,
  role12Icon,
  role13Icon,
  role14Icon,
  role15Icon,
  role16Icon,
  role17Icon,
  role18Icon,
  role19Icon,
  role20Icon,
  role21Icon,
  role22Icon,
  role23Icon,
  role24Icon,
  role25Icon,
  role26Icon,
  role27Icon,
  role28Icon,
  role29Icon,
  role30Icon,
  role31Icon,
  role32Icon,
  role33Icon,
  partiallyCompleteCheckboxIcon,
  whiteCloseIcon,
  eyeOnIcon,
  eyeOffIcon,
  appLogoIcon,
  dropdownGrayIcon,
  binBlackIcon,
  admin,
  shiftManager,
  bar,
  barManager,
  bookKeeper,
  lineCook,
  waiter,
  restaurantChainManager,
  restaurantTrainee,
  pastryChef,
  chef,
  checkTickBg,
  passwordLock,
  editPenCircle,
  regularAnnouncementRedIcon,
  tutorialsActiveRedIcon,
  administrationRedIcon,
  settingRedIcon,
  regulationPartial,
  errorPartial,
  copyWhiteIcon,
  closeRedIcon,
  thumbsUpGrayIcon,
  thumbsUpGreenIcon,
  thumbsUpBlueIcon,
  organizationGrayIcon,
  darkStarIcon,
  QRDarkIcon,
  shareDarkIcon,
  copyDarkIcon,
  cloneDarkIcon,
  shortAnswerTypeIcon,
  multipleChoiceTypeIcon,
  checkboxTypeIcon,
  linearScaleTypeIcon,
  ratingTypeIcon,
  dateTypeIcon,
  timeTypeIcon,
  emptyStarIcon,
  filledStarIcon,
  filledStarDropdownIcon,
  emptyHeartIcon,
  filledHeartIcon,
  filledHeartDropdownIcon,
  emptySmileIcon,
  filledSmileIcon,
  filledSmileDropdownIcon,
  emptyGlassIcon,
  filledGlassIcon,
  filledGlassDropdownIcon,
  calendarBlackIcon,
  prevBlackIcon,
  nextBlackIcon,
  lessThanWhiteIcon,
  exclamationCircleIcon,
  micIcon,
  timeIcon,
  tableIcon,
  whatsAppIcon,
  emailIcon,
  quickTypeIcon,
  draftBlueIcon,
  tableReservationGrayIcon,
  printTableIcon,
  menuTypeIcon,
  dropdownQuestionTypeIcon,
  uploadQuestionTypeIcon,
  rangeQuestionTypeIcon,
  regularAnnouncementOutlineIcon,
  aquaStarIcon,
  logoutWhiteIcon,
  logoIcon,
  logoDarkIcon,
  cheqqItTickIcon,
  networkBlackIcon,
  editSettingsWhiteIcon,
  imgPlaceholderWhiteIcon,
  goBackIcon,
  addDarkBlueIcon,
  copyGrayIcon,
  infoBlueIcon,
  tickWhiteIcon,
  folderBlackIcon,
  reWindGrayIcon,
  bellBlackIcon,
  yellowCircleIcon,
  grayCircleIcon,
  activateCheckIcon,
  activeCheckIcon,
  arrowRound,
  regulationBadgeGroup,
  regulationBadgeIcon,
  validationErrorOnboarding,
  bellFilledBlackIcon,
  daySummrayIcon,
  enterArrowIcon,
  checkTickIcon,
  networkParentIcon,
};

export const IMAGES = {
  logo: require('../assets/images/Cheq-Qit.png'),
  englishFlag: require('../assets/images/englishFlag.png'),
  israelFlag: require('../assets/images/israelFlag.png'),
  restaurant: require('../assets/images/restaurant.png'),
  placeholder: require('../assets/images/placeholder.png'),
  calendarScreen: require('../assets/images/calendarScreen.png'),
  briefScreen: require('../assets/images/briefScreen.png'),
};
